import {useQuery} from "@tanstack/react-query";
import {QueryKeys} from "@/Service/Api/V1/QueryKeys/QueryKeys";
import {MiscApiClient} from "@/Service/Api/V1/ApiClients/MiscApiClient";

export type useGetUserGuideParams = {
    enabled?: boolean
};

export const useGetUserGuide = ({enabled}: useGetUserGuideParams) => useQuery({
    ...QueryKeys.misc.userGuide(),
    queryFn: async () => await MiscApiClient.getUserGuide(),
    enabled,
    retry: false
});